import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTick = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill='none' viewBox='0 0 24 24' {...props} data-sentry-element="svg" data-sentry-component="SvgTick" data-sentry-source-file="Tick.tsx">
            <path fill='currentColor' d='M10.58 15.58a.75.75 0 0 1-.53-.22l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-5.67 5.67a.75.75 0 0 1-.53.22' data-sentry-element="path" data-sentry-source-file="Tick.tsx" />
        </svg>;
};
export default SvgTick;